import type { EventNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { Bold, Times, Within, SubFilters } from '../condition-parts';

type EventConditionProps = { node: EventNode };

export function EventCondition({ node }: EventConditionProps) {
  const operator = node.inverse ? 'not performed' : 'performed';
  return (
    <ConditionCard node={node}>
      <Bold>{node.name}</Bold> {operator}
      <Times times={node.times} />
      <Within within={node.within} />
      <SubFilters filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionCard>
  );
}
